import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import settings from './modules/settings'
import pageCache from './modules/pageCache'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		settings,
		pageCache
	},
	state: {
		dictsMap: {},
		generalComponentState: {
			isShowHeader: false,
			isShowFooter: false,
			isSetPadding: false
		},
		routerLocation: '',
		screenshotModeActive: false,
		userInfo: {
			role: 1
		}
	},
	mutations: {
		setDictsMap(state, obj) {
			state.dictsMap[obj.key] = obj.data
		},
		setStateBasic(state, obj) {
			state[obj.paramName] = obj.val
		},
		setStateObj(state, obj) {
			state[obj.paramName] = {
				...state[obj.paramName],
				...obj.val
			}
		}
	},
	plugins: [
		createPersistedState({
			storage: window.localStorage,
			reducer(val) {
				return {
					generalComponentState: val.generalComponentState,
					userInfo: val.userInfo
				}
			}
		})
	]
})

export default store